<template>
  <div class="container">
    <div class="row">
      <div v-if="description" class="col-md-7" v-html="description"></div>
      <div :class="description ? ['col-md-4', 'offset-md-1'] : 'col'">
        <div
          class="row ps-0 pt-5 pt-md-0"
          v-for="question in questions"
          :key="question.id"
        >
          <div
            v-if="question.label"
            class="col-md-6 d-flex align-items-md-end"
            v-html="question.label"
          ></div>
          <div class="col-md-1"></div>
          <div class="col-md-5 pe-0">
            <div class="row d-flex justify-content-around">
              <div
                class="col-1 pl-md-1 d-flex align-items-center justify-content-center mb-0"
                v-for="choice in question.choices"
                :key="choice"
              >
                <input
                  :id="`radio-${question.id}-${choice}`"
                  type="radio"
                  :name="'radio-group-' + question.id"
                  v-model="question.response"
                  :value="choice - 1"
                  v-on:change="handleInputCompleted"
                  style="display: none"
                />
                <label
                  class="text-center"
                  :for="`radio-${question.id}-${choice}`"
                >
                  <img
                    :src="`/static/img/${
                      ['Dislike', 'NeitherLikeNorDislike', 'Like'][choice - 1]
                    }.svg`"
                    :title="choice"
                    style="width: 32px"
                  />
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <label
    class="likert-radio-label-vertical"
    :for="'input-' + question.id + '-' + choice"
  >
    {{
      [
        "Strongly Disagree",
        "Disagree",
        "Neither Agree nor Disagree",
        "Agree",
        "Strongly Agree",
      ][choice - 1]
    }}
    <input
      :id="'input-' + question.id + '-' + choice"
      class="my-auto form-check-input"
      type="radio"
      :name="'radio-group-' + question.id"
      v-model="question.response"
      v-on:change="handleInputCompleted"
      :value="choice - 1"
    />
  </label>
  <div class="container">
    <div class="row">
      <div v-if="description" class="col-md-7" v-html="description"></div>
      <div :class="description ? ['col-md-4', 'offset-md-1'] : 'col'">
        <div class="row" v-for="question in questions" v-bind:key="question.id">
          <div
            v-if="question.label"
            class="col-md-7"
            v-html="question.label"
          ></div>
          <div v-if="question.description" class="col-md-7">
            <p v-html="question.description"></p>
          </div>
          <div class="col-md-5 d-flex justify-content-end pe-0">
            <div :class="[description ? 'justify-content-around' : '', 'row']">
              <div class="col d-flex align-items-end">
                <div
                  class="form-check form-check-inline"
                  v-for="(choice, index) in question.choices"
                  :key="question.id * 100 + index"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
export default {
  name: 'LikertScaleIcons3'
}
</script>
